<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.stmtType"
                          :label="labels.stmtType"
                          :error-messages="errors.collect('filters.stmtType')"
                          data-vv-name="filters.stmtType"
                          :data-vv-as="labels.stmtType"
                          append-icon="mdi-magnify"
                          @click:append="getHelpList('stmtType')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.tgtLnType"
                          :label="labels.tgtLnType"
                          :error-messages="errors.collect('filters.tgtLnType')"
                          data-vv-name="filters.tgtLnType"
                          :data-vv-as="labels.tgtLnType"
                          append-icon="mdi-magnify"
                          @click:append="getHelpList('tgtLnType')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-autocomplete
                          :items="stmtLvlList"
                          :label="labels.stmtLvl"
                          v-model="filters.stmtLvl"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('filters.stmtLvl')"
                          data-vv-name="filters.stmtLvl"
                          :data-vv-as="labels.stmtLvl"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ labels.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="name"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td class="text-xs-left">{{ row.item.stmtType }}</td>
                      <td class="text-xs-left">{{ row.item.stmtLvl }}</td>
                      <td class="text-xs-left">{{ row.item.stmtLnSeq }}</td>
                      <td class="text-xs-left">{{ row.item.tgtLnType }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          query
                          @query="doQuery(row.item)"
                          review
                          @review="doReview(row.item)"
                          remove
                          @remove="doPromptRemove(row.item)"
                        ></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="filterHelplist" width="900px" persistent>
      <!-- Helplist component -->
      <stmtLnType-help-list v-if="stmtLnTypeHelplist" @close="doClose" @selectStmtLnType="doAssign($event)"></stmtLnType-help-list>
      <stmtType-help-list v-if="stmtTypeHelplist" @close="doClose" @selectStmtType="doAssign($event)"></stmtType-help-list>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure to delete the selected Line Calculation by Statement Type? - riType: {{ selected.riType }}, tgtLnType: {{ selected.tgtLnType }},
      stmtLvl: {{ selected.stmtLvl }}, stmtLnSeq: {{ selected.stmtLnSeq }}
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import StmtLnTypeHelplist from './helplist/StmtLnTypeHelplist.vue'
import StmtTypeHelplist from './helplist/StmtTypeHelplist.vue'
import { expandURI, filterQuery } from '@/utils/ajax'
import { stmtLvl } from '@/const/params'
import { formatDisplayDate } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      loading: false,
      promptRemove: false,
      filterHelplist: false,
      stmtTypeHelplist: false,
      stmtLnTypeHelplist: false,
      items: [],
      totalItems: 0,
      selected: {
        riType: null,
        tgtLnType: null,
        stmtLvl: null,
        stmtLnSeq: null
      },
      toggleArray: [false],
      labels: {
        newButton: 'New Line Calculation',
        stmtType: 'Statement Type',
        tgtLnType: 'Target Statement Line Type',
        stmtLvl: 'Statement Level',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        date: 'date'
      },
      filters: {
        stmtType: null,
        stmtLvl: null,
        tgtLnType: null
      },
      headers: [
        { text: 'Statement Type', value: 'stmtType' },
        { text: 'Statement Level', value: 'srcStmtLnType' },
        { text: 'Statement Line Seq', value: 'stmtLnSeq' },
        { text: 'Target Statement Line Type', value: 'tgtLnType' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.fetchData(false)
    },
    doClearFilters() {
      this.filters.stmtType = null
      this.filters.stmtLvl = null
      this.filters.tgtLnType = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.fetchData(false)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getStmtTypeLnCalcPage
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((stmtTypeLnCalc) => {
                const convertList = {
                  riType: stmtTypeLnCalc.riType,
                  stmtType: stmtTypeLnCalc.stmtType,
                  stmtLvl: stmtTypeLnCalc.stmtLvl,
                  stmtLnSeq: stmtTypeLnCalc.stmtLnSeq,
                  tgtLnType: stmtTypeLnCalc.tgtLnType
                }
                this.items.push(convertList)
              })
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    doNew() {
      this.$router.push({ name: 'stmtTypeLnCalcDet', params: { stmtTypeLnCalc: 'new', tranMode: 'New' } })
    },
    doQuery(data) {
      this.$router.push({ name: 'stmtTypeLnCalcDet', params: { stmtTypeLnCalc: data, tranMode: 'Query' } })
    },
    doReview(data) {
      this.$router.push({ name: 'stmtTypeLnCalcDet', params: { stmtTypeLnCalc: data, tranMode: 'Review' } })
    },
    doDelete() {
      this.resetMessages()
      if (this.selected) {
        const apiURI = this.menu.deleteStmtTypeLnCalc
        if (apiURI) {
          const expand = {
            riType: this.selected.riType,
            stmtType: this.selected.stmtType,
            stmtLvl: this.selected.stmtLvl,
            stmtLnSeq: this.selected.stmtLnSeq
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selected = data
      this.promptRemove = true
      this.selected.riType = data.riType
      this.selected.stmtType = data.stmtType
      this.selected.stmtLvl = data.stmtLvl
      this.selected.stmtLnSeq = data.stmtLnSeq
    },
    getHelpList(fieldName) {
      this.filterHelplist = true
      switch (fieldName) {
        case 'stmtType':
          this.fieldName = 'stmtType'
          this.stmtTypeHelplist = true
          break
        case 'tgtLnType':
          this.fieldName = 'tgtLnType'
          this.stmtLnTypeHelplist = true
          break
        default:
          this.fieldName = undefined
          this.stmtTypeHelplist = false
          this.stmtLnTypeHelplist = false
      }
    },
    doAssign(stmtTypeObj) {
      switch (this.fieldName) {
        case 'stmtType':
          this.filters.stmtType = stmtTypeObj.stmtType
          break
        case 'tgtLnType':
          this.filters.tgtLnType = stmtTypeObj.stmtLnType
          break
        default:
          this.fieldName = undefined
      }
      this.fieldName = undefined
      this.stmtLnTypeHelplist = false
      this.filterHelplist = false
    },
    doClose() {
      this.resetMessages()
      this.filterHelplist = false
      setTimeout(() => {
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = false
      }, 500)
    }
  },
  computed: {
    menu() {
      return this.$store.state.lnCalc.menu
    },
    stmtLvlList() {
      let result = []
      Object.keys(stmtLvl).forEach(function (key) {
        const status = stmtLvl[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'stmtLnType-help-list': StmtLnTypeHelplist,
    'stmtType-help-list': StmtTypeHelplist
  }
}
</script>
